export default "__VITE_ASSET__8Jdj9qQ4eJq3labUJOvRYQ__ 480w, __VITE_ASSET__zOyQqdNGsn0lL_XEFrarVA__ 768w, __VITE_ASSET__EsSyonNWXFChOyjfj2S3nw__ 1200w";